export const DROP_OFF_CITIES_QUERY = 'DROP_OFF_CITIES_QUERY';

export const PAYMENT_SETTINGS_QUERY = 'PAYMENT_SETTINGS_QUERY';

export const BOOKING_HISTORY_DETAILS_QUERY = 'BOOKING_HISTORY_DETAILS_QUERY';

export const HAS_BOOKING_IN_RANGE_QUERY = 'HAS_BOOKING_IN_RANGE_QUERY';

export const KEY_REWARD_PROGRAM_COLLECTION_QUERY =
	'KEY_REWARD_PROGRAM_COLLECTION_QUERY';
